import React from "react";
import { Link } from "react-router-dom";

export default () => (
  <div className="pb4 mt6 tc b" style={{ minHeight: 300 }}>
    <p>404 - page is unavailable</p>
    <Link to="/" className="dim underline">
      Home
    </Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/noMatch.js